import * as actionTypes from "../actions/actionTypes";
import { updateObject } from "../../util/utility";

const initialState = {
  files: [],
  loading: false,
  error: false,
  errorCode: null,
  msg: null,
  success: false,
};

const resetUserStore = (state, action) => {
  return updateObject(state, initialState);
};

const showUserGenHistoryStart = (state, action) => {
  return updateObject(state, {
    loading: true,
  });
};

const showUserGenHistorySuccess = (state, action) => {
  return updateObject(state, {
    loading: false,
    error: false,
    files: action.files,
    success: true,
  });
};

const showUserGenHistoryFail = (state, action) => {
  return updateObject(state, {
    error: true,
    loading: false,
    errorCode: action.error,
  });
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.RESET_SEARCH_STORE:
      return resetUserStore(state, action);

    case actionTypes.SHOW_USER_GENERATION_HISTORY_START:
      return showUserGenHistoryStart(state, action);

    case actionTypes.SHOW_USER_GENERATION_HISTORY_SUCCESS:
      return showUserGenHistorySuccess(state, action);

    case actionTypes.SHOW_USER_GENERATION_HISTORY_FAIL:
      return showUserGenHistoryFail(state, action);

    default:
      return state;
  }
};

export default reducer;
